import React from 'react'
import { MenuLineHorizontalHalf } from 'react-huge-icons/outline'
import { matchPath, useLocation } from 'react-router-dom'
import AppRoutes from '../constants/Routes'
import { useTranslation } from 'react-i18next'
import { useSession } from 'src/features/auth'
import { useGetCurrentMemberQuery } from 'src/graphql'


interface HeaderProps {
    onMenuButtonClick: () => any
}

const Header: React.FC<HeaderProps> = ({ onMenuButtonClick }) => {
    const { t } = useTranslation();
    const { data, loading, error } = useGetCurrentMemberQuery();
    console.log(data, loading, error);
    const location = useLocation();
    const title = `${t("welcome_back")}, ${data?.getCurrentMember?.name}`; // from redux
    const subtitle = AppRoutes.find((r) => matchPath(location.pathname, r.href))?.label || "";
    return (
        <div className='font-Poppins flex items-start md:items-center mt-2 md:my-3 md:mx-2 h-10'>
            {/* 
            <button className=' md:hidden  hover:bg-light/10' onClick={onMenuButtonClick} >
                <MenuLineHorizontalHalf className='w-8 h-8 text-[#28303F] ' />
            </button> */}

            <div className='flex w-full md:justify-start'>
                <div>
                    <h1 className='text-base font-semibold md:text-xl md:font-semibold text-dark'>{title} 👏🏻</h1>
                    <p className='text-xs md:text-md md:font-semibold text-light-secondary'>{t(subtitle)}</p>
                </div>
            </div>
        </div>

    )
}

export default Header